import { NgModule, NO_ERRORS_SCHEMA } from '@angular/core';
import { RouterModule } from '@angular/router';
import { CommonModule } from '@angular/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { NgbModule } from '@ng-bootstrap/ng-bootstrap';
// import { TagInputModule } from 'ngx-chips';
import {ConfirmationPopoverModule} from 'angular-confirmation-popover';
import { NgxLoadingModule, ngxLoadingAnimationTypes } from 'ngx-loading';
import { InfiniteScrollModule } from 'ngx-infinite-scroll';
import { EditorModule } from '@tinymce/tinymce-angular';
import {GooglePlaceModule} from 'ngx-google-places-autocomplete';

import { Ng2StickyModule } from 'ng2-sticky';

import { FooterComponent } from './components/footer/footer.component';
import { HeaderComponent } from './components/header/header.component';
import { ResumePreviewComponent } from '../shared/components/modal/resume-preview/resume-preview.component';
import { PaymentComponent } from './components/modal/payment/payment.component';
import {UtilService} from './services/util.service';
import { AngularCropperjsComponent } from './components/angular-cropperjs/angular-cropperjs.component';
import { ImgEditModalComponent } from './components/modal/img-edit-modal/img-edit-modal.component';
import { UtilComponentsComponent, MyDatePickerComponent } from './components/util-components/util-components.component';

import { SharedService } from './services/shared.service';
import { StickyFixDirective } from './directives/sticky-fix.directive'

import { FilterPipe } from './pipe/filter.pipe';

@NgModule({
  imports: [
    RouterModule,
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    NgbModule,
    // TagInputModule,
    ConfirmationPopoverModule.forRoot({
      confirmButtonType: 'danger' // set defaults here
    }),
    NgxLoadingModule.forRoot({
      animationType: ngxLoadingAnimationTypes.cubeGrid,
      backdropBackgroundColour: 'rgba(0,0,0,0.1)',
      backdropBorderRadius: '4px',
      primaryColour: '#006cf7',
      secondaryColour: '#006cf7',
      tertiaryColour: '#006cf7'
    }),
    InfiniteScrollModule,
    EditorModule,
    GooglePlaceModule,
    Ng2StickyModule
  ],
  entryComponents: [
    ResumePreviewComponent,
    AngularCropperjsComponent,
    ImgEditModalComponent,
    PaymentComponent
  ],
  declarations: [
    FooterComponent,
    HeaderComponent,
    ResumePreviewComponent,
    AngularCropperjsComponent,
    ImgEditModalComponent,
    MyDatePickerComponent,
    UtilComponentsComponent,
    StickyFixDirective,
    FilterPipe,
    PaymentComponent
  ],
  exports: [
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    NgbModule,
    // TagInputModule,
    FooterComponent,
    HeaderComponent,
    ResumePreviewComponent,
    ImgEditModalComponent,
    AngularCropperjsComponent,
    ConfirmationPopoverModule,
    NgxLoadingModule,
    InfiniteScrollModule,
    EditorModule,
    GooglePlaceModule,
    Ng2StickyModule,
    MyDatePickerComponent,
    UtilComponentsComponent,
    StickyFixDirective,
    FilterPipe
  ],
  providers: [
    UtilService,
    SharedService
  ],
  schemas: [NO_ERRORS_SCHEMA]
})
export class SharedModule { }
